"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var s = _interopRequireWildcard(require("./style"));

var FileStack =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FileStack, _React$Component);

  function FileStack() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FileStack);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FileStack)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "open", function () {
      var _this$props = _this.props,
          fromSources = _this$props.fromSources,
          maxFiles = _this$props.maxFiles,
          minFiles = _this$props.minFiles,
          accept = _this$props.accept,
          onOpen = _this$props.onOpen,
          onFileUploadFailed = _this$props.onFileUploadFailed,
          onFileUploadFinished = _this$props.onFileUploadFinished;
      window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz');
      window.fs_filepicker.picker({
        fromSources: fromSources,
        maxFiles: maxFiles,
        minFiles: minFiles,
        accept: accept,
        onOpen: onOpen,
        onFileUploadFailed: onFileUploadFailed,
        onFileUploadFinished: onFileUploadFinished
      }).open();
    });
    return _this;
  }

  (0, _createClass2.default)(FileStack, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        onClick: this.open,
        role: "button",
        tabIndex: "-1",
        className: s.fileStackRoot
      }, this.props.children);
    }
  }]);
  return FileStack;
}(_react.default.Component);

FileStack.defaultProps = {
  fromSources: ['local_file_system', 'url', 'imagesearch', 'facebook', 'instagram', 'googledrive', 'github', 'webcam'],
  maxFiles: 1,
  minFiles: 1,
  accept: ['image/*'],
  onOpen: console.log,
  onFileUploadFailed: console.log,
  onFileUploadFinished: console.log
};
FileStack.propTypes = {
  fromSources: _propTypes.default.array,
  maxFiles: _propTypes.default.bool,
  minFiles: _propTypes.default.bool,
  accept: _propTypes.default.array,
  onOpen: _propTypes.default.func,
  onFileUploadFailed: _propTypes.default.func,
  onFileUploadFinished: _propTypes.default.func
};
var _default = FileStack;
exports.default = _default;